import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig, AxiosHeaders, AxiosRequestHeaders } from "axios";
import { API_BASE_URL } from "../config";
import { TokenStorage } from "./TokenStorage";
import { NavigationService } from "./NavigationService";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    // Add Authorization header if token exists
    const token = TokenStorage.getToken();
    if (token) {
      if (!config.headers) {
        config.headers = AxiosHeaders.from({});
      }

      if (config.headers instanceof AxiosHeaders) {
        config.headers.set("Authorization", `Bearer ${token}`);
      } else {
        (config.headers as AxiosRequestHeaders)["Authorization"] = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error: AxiosError) => {
    console.error(`[request error] [${JSON.stringify(error)}]`);
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response;
  },
  async (error: AxiosError) => {
    // Handle 401 errors by clearing invalid tokens
    if (error.response?.status === 401) {
      TokenStorage.clearToken();
      NavigationService.navigateToLogin();
    }

    console.error(`[response error] [${JSON.stringify(error)}]`);
    return Promise.reject(error);
  },
);

export default axiosInstance;
